<template>
  <v-container fluid class="ask-mentor pa-0">
    <template v-if="loading">
      <v-overlay :value="loading">
        <v-progress-circular
          :size="100"
          color="white"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </template>

    <template v-else>
      <banner :title="title" :description="description" />

      <div class="mission-section my-12">
        <v-container>
          <v-row justify="center" no-gutters>
            <v-col cols="12" md="5" lg="4">
              <h2
                class="font-weight-medium display-1"
                v-text="classMissionTitle"
              ></h2>
            </v-col>
            <v-col cols="12" md="5" lg="4">
              <p class="description" v-text="classMissionDescription"></p>
              <p class="description" v-text="classMissionDescription1"></p>
              <p class="description" v-text="classMissionDescription2"></p>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <div class="class-informations">
        <v-container>
          <v-row class="mb-12" justify="center" no-gutters>
            <v-col cols="12" md="5" lg="4">
              <h2
                class="font-weight-medium display-1"
                v-text="aboutTutorsTitle"
              ></h2>
            </v-col>
            <v-col cols="12" md="5" lg="4">
              <p class="description">
                The OWL tutors are professional staff members and peer tutors in
                Academic Support at Cardinal Stritch University. The OWL tutors
                are happy to share their writing expertise with you; however, as
                many aspects of writing are easier to explain in person than via
                email, you are encouraged to consult with your class instructor
                or a tutor in Academic Support if necessary.
              </p>
            </v-col>
          </v-row>
          <v-row class="mb-12" justify="center" no-gutters>
            <v-col cols="12" md="5" lg="4">
              <h2
                class="font-weight-medium display-1"
                v-text="classUsageTitle"
              ></h2>
            </v-col>
            <v-col cols="12" md="5" lg="4">
              <p class="description" v-text="classUsageDescription"></p>
            </v-col>
          </v-row>
          <v-row justify="center" no-gutters>
            <v-col cols="12" md="5" lg="4">
              <h2
                class="font-weight-medium display-1"
                v-text="classLimitationsTitle"
              ></h2>
            </v-col>
            <v-col cols="12" md="5" lg="4">
              <ul class="limitations-list">
                <li v-text="classLimitationDescription"></li>
                <li v-text="classLimitationDescriptionFeedback"></li>
                <li v-text="classLimitationDescriptionRewrite"></li>
              </ul>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <div class="document-decsription">
        <v-container>
          <v-row justify="center" no-gutters>
            <v-col cols="12" md="4" lg="4">
              <h2
                class="font-weight-medium display-1"
                v-text="FormatRequirement"
              ></h2>
              <v-container class="pl-0">
                <p
                  class="formatDescriptionText"
                  v-text="formatDescription1"
                ></p>
                <p class="formatDescriptionText">
                  Contact
                  <a href="mailto: support@class-solutions.net"
                    >support@class-solutions.net</a
                  >
                  to learn more about downloading Microsoft Word and other
                  Office products for FREE!
                </p>
              </v-container>
            </v-col>
            <v-col cols="12" md="6" lg="4">
              <img src="../../assets/images/format-requirments.png" alt="" />
            </v-col>
          </v-row>
        </v-container>
      </div>

      <div class="paper-information">
        <v-container>
          <v-row class="mb-12" justify="center" no-gutters>
            <v-col cols="12" md="10" lg="4">
              <p class="formInfoText" v-text="formInfo"></p>
            </v-col>
            <v-col cols="12" lg="4"> </v-col>
          </v-row>
          <v-row class="mb-12" justify="center" no-gutters>
            <v-col
              cols="12 text-left"
              sm="12"
              md="3"
              lg="2"
              class="steps"
              v-text="$t('1. Quick Details')"
            ></v-col>
            <v-col
              cols="12 text-left"
              sm="12"
              md="3"
              lg="3"
              class="steps"
              v-text="$t('2. PaperDetails')"
            ></v-col>
            <v-col
              cols="12 text-left"
              sm="12"
              md="3"
              lg="3"
              class="steps"
              v-text="$t('3. Submit Paper')"
            ></v-col>
          </v-row>
        </v-container>

        <v-container>
          <v-row class="mb-5" justify="center" no-gutters>
            <v-col cols="12" md="10" lg="8">
              <h2 class="submission-text" v-text="$t('SubmissionForm')"></h2>

              <h4
                class="lerner-information"
                v-text="$t(`Learner's Information`)"
              ></h4>

              <div class="thick-line"></div>
            </v-col>
          </v-row>

          <v-row class="mb-10" justify="center" no-gutters>
            <v-col cols="12" sm="12" md="5" lg="4">
              <v-text-field
                readonly
                rounded
                outlined
                persistent-hint
                validate-on-blur
                :label="$t('FirstName')"
                v-model="student.studentFirstName"
                class="mb-2"
              ></v-text-field>
            </v-col>
            <v-col class="ml-4" cols="12" sm="12" md="5" lg="4">
              <v-text-field
                readonly
                rounded
                outlined
                persistent-hint
                validate-on-blur
                :label="$t('LastName')"
                v-model="student.studentLastName"
                class="mb-2"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-10" justify="center" no-gutters>
            <v-col cols="12" sm="12" md="5" lg="4">
              <v-text-field
                readonly
                rounded
                outlined
                persistent-hint
                validate-on-blur
                :label="$t('Email')"
                v-model="student.student.email"
                class="mb-2"
              ></v-text-field>
            </v-col>
            <v-col class="ml-4" cols="12" sm="12" md="5" lg="4">
              <v-text-field
                readonly
                rounded
                outlined
                v-model="student.student.phone"
                :label="$t('PhoneNumber')"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mb-5" justify="center" no-gutters>
            <v-col cols="12" md="10" lg="8">
              <h2 class="paper-details">Paper Details</h2>

              <div class="thick-line"></div>
            </v-col>
          </v-row>

          <v-form
            ref="paperForm"
            v-model="valid"
            lazy-validation
            @submit.prevent="submitDocument"
          >
            <v-row justify="center" no-gutters>
              <v-col cols="12" sm="12" md="5" lg="4">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  max-width="290"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      rounded
                      :rules="dueDateRules"
                      :value="computedDateFormattedMomentjs"
                      v-model="documentObjectFinal.assignmentDueDate"
                      append-icon="fa-solid fa-calendar-days"
                      label="Assignment Due Date"
                      v-bind="attrs"
                      v-on="on"
                      @click:clear="date = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="documentObjectFinal.assignmentDueDate"
                    @change="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="ml-4" cols="12" sm="12" md="5" lg="4">
                <v-select
                  rounded
                  outlined
                  required
                  :rules="educationLevelIdRules"
                  v-model="documentObjectFinal.educationLevelId"
                  :items="educationCoursesMajor"
                  item-text="label"
                  item-value="id"
                  class="mb-2"
                  :label="$t('Education Level*')"
                  :menu-props="{ offsetY: true }"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="5" lg="4">
                <v-select
                  rounded
                  outlined
                  required
                  :rules="majorIdRules"
                  v-model="documentObjectFinal.majorId"
                  :items="major"
                  item-text="label"
                  item-value="id"
                  class="mb-2"
                  :label="$t('Major*')"
                  :menu-props="{ offsetY: true }"
                ></v-select>
              </v-col>
              <v-col class="ml-4" cols="12" sm="12" md="5" lg="4">
                <v-select
                  rounded
                  outlined
                  required
                  :rules="courseIdRules"
                  v-model="documentObjectFinal.courseId"
                  :items="courses"
                  item-text="label"
                  item-value="id"
                  class="mb-2"
                  :label="$t('Course*')"
                  :menu-props="{ offsetY: true }"
                ></v-select>
              </v-col>

              <!-- <v-btn @click="clear">
                        clear
                        </v-btn> -->
            </v-row>
            <v-row
              class="mb-10"
              justify="center"
              no-gutters
              style="margin-top: -37px; margin-bottom: 70px !important"
            >
              <v-col
                class="col-sm-12 col-md-5 col-lg-4"
                cols="12"
                
                offset-lg="1"
                offset-md="1"
                v-for="areas in articles"
                :key="areas.id"
              >
                <h1 class="category-title" id="scrollableDiv">
                  {{ areas.name }}
                </h1>

                <template
                  v-if="
                    areas.isMultiSelect == true &&
                    areas.paperRequestArticles.length !== 0
                  "
                >
                  <div
                    v-for="areasInfo in areas.paperRequestArticles"
                    :key="areasInfo.id"
                  >
                    <v-checkbox
                      style="margin-bottom: -15px"
                      class="mt-0 pt-0"
                      v-model="areasInfo.value"
                      :value="areasInfo.id"
                      :id="areasInfo.id.toString()"
                      :label="areasInfo.label"
                      required
                    ></v-checkbox>
                  </div>
                  <p class="error-color" v-if="checkHello">{{ msg }}</p>
                </template>
                <template
                  v-else-if="
                    areas.isMultiSelect == false &&
                    areas.paperRequestArticles.length !== 0
                  "
                >
                  <div>
                    <v-radio-group
                      style="margin-top: 0px"
                      v-model="radioButtonValue"
                    >
                      <v-radio
                        v-for="areasInfo in areas.paperRequestArticles"
                        style="maring-bottom: 5px"
                        required
                        :key="areasInfo.id"
                        :label="areasInfo.label"
                        :value="areasInfo.id"
                      ></v-radio>
                    </v-radio-group>
                    <p class="error-color" v-if="hello">{{ msg }}</p>
                  </div>
                </template>
              </v-col>
            </v-row>
            <v-row justify="center" no-gutters>
              <v-col cols="12" sm="12" md="10" lg="8">
                <p v-text="InorderOfPriority"></p>
              </v-col>
            </v-row>
            <v-row class="mb-10" justify="center" no-gutters>
              <v-col cols="12" sm="12" md="5" lg="4">
                <v-text-field
                  rounded
                  v-model="documentObjectFinal.issues"
                  :label="$t('Write here…')"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="4" sm="12" md="5" lg="4"> </v-col>
            </v-row>

            <v-row class="mb-10" justify="center" no-gutters>
              <v-col cols="12" md="10" lg="8">
                <h2 class="submit-paper-title" v-text="$t('SubmitPaper')"></h2>
                <div class="thick-line"></div>
              </v-col>
            </v-row>
            <v-row justify="center" no-gutters>
              <v-col cols="12" sm="12" md="5" lg="4">
                <p class="mt-auto" v-text="$t('AcceptedFileTypes')"></p>
                <v-file-input
                  class="file-input"
                  ref="fileeee"
                  rounded
                  outlined
                  v-model="file"
                  prepend-inner-icon="fa-sharp fa-solid fa-file-export"
                  :rules="vFileRules"
                  required
                  accept=".docx, .doc"
                  prepend-icon=""
                  :label="$t('Upload your draft')"
                  @change="docUploadEventHandler"
                ></v-file-input>
              </v-col>
              <v-col class="ml-4" cols="12" sm="12" md="5" lg="4">
                <p v-text="$t('DescribeYourWritingAssignment')"></p>
                <v-text-field
                  rounded
                  error-messages=""
                  outlined
                  :rules="additionalCommentsRules"
                  v-model="documentObjectFinal.additionalComments"
                  :label="$t('Additional Comments*')"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="mb-10" justify="center" no-gutters>
              <v-col class="ml-4" cols="12" sm="12" md="10" lg="4">
                <v-checkbox
                  v-model="documentObjectFinal.isNativeLanguage"
                  :label="$t('English is not my native language')"
                ></v-checkbox>
              </v-col>
              <v-col cols="4" sm="12" lg="4"> </v-col>
            </v-row>
            <v-row class="mb-10" justify="center" no-gutters>
              <v-col cols="4" sm="12" md="4" lg="4">
                <v-btn
                  :disabled="!valid || btnDisable"
                  class="submitBtn"
                  @click="submitDocument()"
                >Submit
                </v-btn>
              </v-col>
            </v-row>
            <template v-if="countedWordsOfDoc && priceOfCountedWordsOfDoc">
              <v-row class="mb-10" justify="center" no-gutters>
                <v-col cols="12" md="10" lg="4">
                  <h2 class="paper-details">{{ $t("BillingPageTitle") }}</h2>

                  <div class="thick-line"></div>
                  <p class="mt-1">
                    This paper has {{ countedWordsOfDoc }} words, total Cost for
                    this paper = ${{ priceOfCountedWordsOfDoc }}
                  </p>
                  <v-checkbox
                    v-model="acceptPayment"
                    :label="$t('AcceptPayement')"
                  ></v-checkbox>
                  <v-checkbox :label="$t(`Please note`)"></v-checkbox>
                </v-col>
                <v-col cols="12" lg="4"> </v-col>
              </v-row>
              <v-row class="mb-10" justify="center" no-gutters>
                <v-col class="ml-4" cols="4" sm="12" md="4" lg="4">
                  <v-btn
                    class="submitBtn"
                    :disabled="!acceptPayment"
                    @click="submitFormToStripe()"
                  >
                  Submit
                  </v-btn>
                </v-col>
              </v-row>
            </template>
          </v-form>
        </v-container>
      </div>
    </template>
  </v-container>
</template>

<script>
import TutorCard from "@/components/tutorProfileCard";
import Banner from "@/components/pageBanerStudentForm";
import { mapGetters } from "vuex";
// import { validationMixin } from "vuelidate";
// import { required, maxLength, email } from "vuelidate/lib/validators";
import moment from "moment";
import { format, parseISO } from "date-fns";
import "@fortawesome/fontawesome-free/css/all.css";
import VueBase64FileUpload from "vue-base64-file-upload";
import { th } from "date-fns/locale";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
export default {
  name: "askMentorForm",
  //   mixins: [validationMixin],
  //   icons: {
  //     iconfont: "fa",
  //   },
  //   validations: {
  //     name: { required, maxLength: maxLength(10) },
  //     email: { required, email },
  //     select: { required },
  //     checkbox: {
  //       checked(val) {
  //         return val;
  //       },
  //     },
  //   },
  data: () => ({
    valid: true,
    documentObjectFinal: {
      assignmentDueDate: "",
      issues: "",
      additionalComments: "",
      isNativeLanguage: false,
      educationLevelId: null,
      majorId: null,
      courseId: null,
      paperRequestArticles: [
        {
          id: null,
          name: "",
          label: "",
          languageId: 1,
          description: "",
          paperRequestCategoryId: null,
          paperRequestCategory: null,
          studentPaperSubmittedList: null,
        },
      ],
    },
    select: { required },
    radioButtonValue: null,
    selectedAreas: [],
    documentObject: {
      Base64String: "",
      FileName: "",
      FileExtension: "",
    },
    countedWordsOfDoc: "",
    priceOfCountedWordsOfDoc: "",
    snackbar: {
      show: true,
      message: "",
    },
    date: format(parseISO(new Date().toISOString()), "yyyy-MM-dd"),
    // rules: [
    //   (value) =>
    //     !value ||
    //     value.size < 20000 ||
    //     "File size should be less than 20 MB! and File must be .doc or .docx",
    // ],
    file: [],
    ero: "",

    loading: true,
    student: {},
    menu1: false,
    educationLevels: [],
    courses: [],
    major: [],
    articles: [],
    areasOfAssistance: {},
    select: null,
    description: `The Online Writing Lab (CLASS) is a tutorial service, run by 
                        Academic Support, that allows students to submit drafts of 
                        college writing assignments via the online submission form (at the 
                        bottom of this page). CLASS Tutors in Academic Support review 
                        the submissions and send them back to students, within two 
                        business days, with feedback, comments, and suggestions that 
                        address students’ concerns about the assignment.`,
    title: `CLASS Online Writing Lab`,
    classMissionTitle: `CLASS Online Writing Mission – First to Final Drafts`,
    classMissionDescription: `The CLASS Online Writing Mission is to help you express your voice from the First to the Final Draft. As writing experts across the disciplines, CLASS writing consultants will help you convey your ideas in clear, coherent, and focused prose following appropriate conventions.`,
    classMissionDescription1: `Whether you are brainstorming on a first draft or refining for a final draft, the CLASS writing consultants will assist you no matter the genre, assignment, or professional level. Our mission is to help you cultivate and express your ideas and to express them to others in your distant voice at any stage of the writing process.`,
    classMissionDescription2: `We look forward to working with you!`,
    aboutTutorsTitle: `Who are the tutors?`,
    aboutTutorsDescription: `The OWL tutors are professional staff members and peer tutors in 
Academic Support at Cardinal Stritch University. The OWL tutors 
are happy to share their writing expertise with you; however, as 
many aspects of writing are easier to explain in person than via 
email, you are encouraged to consult with your class instructor or 
a tutor in Academic Support if necessary.`,
    classUsageTitle: `Who may use the CLASS? `,
    classUsageDescription: `Only students currently enrolled at Stritch may use the OWL. The 
student must check University email (Wolfmail) regularly to 
receive a response and have access to Microsoft Word in order to 
submit an essay. `,
    InorderOfPriority: `In order of priority, what three issues would you like CLASS to address?`,
    classLimitationsTitle: `What are some of the CLASS limitations?`,
    classLimitationDescription: `Students are limited to one five-page submission per day.`,
    classLimitationDescriptionFeedback: `Turnaround time for feedback on OWL submissions is two business days.`,
    classLimitationDescriptionRewrite: `CLASS staff will not rewrite your essay for you.`,
    classLimitationDescriptionReoair: `CLASS staff will not repair all of your mechanical errors.`,
    FormatRequirement: `Format requirement.`,
    formatDescription1: `CLASS staff use Microsoft Word to provide feedback on student 
                                essays. Staff is unable to use track changes and comment mode 
                                to review PDF or ODT documents. 
                                `,
    formatDescription2: `Contact support@class-solutions.net to learn more about downloading Microsoft Word and other Office products for FREE!`,
    formInfo: `*You will not speak with a live tutor during drop-off paper review. If you need to speak to a writing specialist, you need to book a live CLASS appointment`,
    hello: false,
    acceptPayment: false,
    msg: "Please check one item from the Category",
    btnDisable: false,
    btnDisable2: true,
    educationLevelIdRules: [(v) => !!v || "", (v) => v > 0 || ""],
    dueDateRules: [(v) => !!v || "", (v) => v.length > 0 || ""],
    majorIdRules: [(v) => !!v || "", (v) => v > 0 || ""],
    courseIdRules: [(v) => !!v || "", (v) => v > 0 || ""],
    additionalCommentsRules: [(v) => !!v || "", (v) => v.length > 1 || ""],
    vFileRules: [
      (v) => !!v || "",
      (v) =>
        v.length ||
        v.size <= 21027072 ||
        '"File size should be less than 20 MB! and File must be .doc or .docx"',
    ],

    // formRules: {
    //   dueDate: (val) => { return val.length > 0 ||  ""},
    //   // majorId: (val) => {return val > 0 || ""},
    //   // courseId: (v) => {return v > 0 || ""},
    //   // additionalComments: (val) => {return (val || "").length > 1},
    //   vFile:(val) => {return val.length || val.size < 20000 || '"File size should be less than 20 MB! and File must be .doc or .docx"'}
    // },
  }),
  components: {
    TutorCard,
    Banner,
    ValidationObserver,
    ValidationProvider,
  },
  // watch: {
  //   file: function (newValue, oldValue) {
  //       if ((newValue = this.$refs.fileeee.hasMouseDown)) {
  //       return this.btnDisable;
  //     }
  //     },
  //   },
  //   hello: function(newValue,oldValue){
  //       console.log(checkBoxesValidation);
  //       if(this.checkBoxesValidation == false) {
  //           return this.hello = false
  //       }
  //   },
  computed: {
    ...mapGetters([
      "user",
      "type",
      "baseImageUrl",
      "preferedLanguage",
      "defaultLanguage",
    ]),

    educationLevelIdcomputed: function () {
      return (val) => val || "";
    },
    isFormValid() {
      if (
        this.formRules.vFile &&
        this.formRules.educationLevelId &&
        this.formRules.majorId &&
        this.formRules.courseId &&
        this.formRules.additionalComments
      ) {
        return true;
      } else {
        return false;
      }
    },
    checkBoxesValidation() {
      let selectedAreasFields = [];
      this.articles.forEach((areas) => {
        if (areas.isMultiSelect) {
          areas.paperRequestArticles.forEach((areasInfo) => {
            if (areasInfo.value) {
              const selectedAreaObject = {
                id: null,
                name: "",
                label: "",
                languageId: this.preferedLanguage,
                paperRequestCategory: null,
                studentPaperSubmittedList: null,
              };
              selectedAreasFields.push(selectedAreaObject);
            }
          });
        } else {
          const radiaValue = areas.paperRequestArticles.find(
            (f) => f.id === this.radioButtonValue
          );
          selectedAreasFields.push(radiaValue);
        }
      });
      return selectedAreasFields.includes(undefined);
    },
    checkHello() {
      if (this.checkBoxesValidation == false) {
        this.hello = false;
      }
    },
    isNativeLanguage() {
      return (this.isNativeLanguage = this.preferedLanguage);
    },
    computedDateFormattedMomentjs() {
      return this.date ? moment(this.date).format("LL") : "";
    },
    isDisable() {
      return this.btnDisable;
    },
    checkCategories(value) {
      if (!value) {
        return this.hello == true;
      }
    },
  },
  methods: {
    async submitDocument() {
      this.loading = true;
      const isValid = this.$refs.paperForm.validate();
      if (!isValid && this.checkBoxesValidation) {
        this.hello = true;
        this.loading = false;
        return;
      } else {
        this.btnDisable == true;
        await this.axios
          .post(
            "StudentPaperSubmitted/GetCharactersNumberAndPriceOfDocument",
            this.documentObject
          )
          .then((response) => {
            this.countedWordsOfDoc = response.data.charactersNumber;
            this.priceOfCountedWordsOfDoc = response.data.price;

            this.loading = false;
          });
      }
    },
    submitFormToStripe() {
      this.loading = true;
      let selectedAreasFields = [];

      this.articles.forEach((areas) => {
        if (areas.isMultiSelect) {
          areas.paperRequestArticles.forEach((areasInfo) => {
            if (areasInfo.value) {
              const selectedAreaObject = {
                id: areasInfo.id,
                name: areasInfo.name,
                label: areasInfo.label,
                languageId: this.preferedLanguage,
                paperRequestCategory: null,
                studentPaperSubmittedList: null,
              };
              selectedAreasFields.push(selectedAreaObject);
            }
          });
        } else {
          const radiaValue = areas.paperRequestArticles.find(
            (f) => f.id === this.radioButtonValue
          );
          selectedAreasFields.push(radiaValue);
        }
      });

      if (selectedAreasFields[0] == undefined) {
        setTimeout(() => {
          window.scrollTo({
            top: document.getElementById("scrollableDiv").offsetTop,
            left: 0,
            behavior: "smooth",
          });
        }, 1000);
      }

      const data = {
        AssignmentDueDate: this.documentObjectFinal.assignmentDueDate,
        Issues: this.documentObjectFinal.issues,
        AdditionalComments: this.documentObjectFinal.additionalComments,
        IsNativeLanguage:
          this.documentObjectFinal.isNativeLanguage == true ? 1 : 2,
        EducationLevelId: this.documentObjectFinal.educationLevelId,
        MajorId: this.documentObjectFinal.majorId,
        CourseId: this.documentObjectFinal.courseId,
        paperRequestArticles: selectedAreasFields,
      };
      this.axios
        .post("StudentPaperSubmitted/SaveStudentPaperSubmitted", data)
        .then((response) => {
          this.loading = false;
          this.snackbar.message = "You have complete this order Thank You";
          this.$EventBus.$emit("snackbar", this.snackbar);
          // --- resetForm with && checkboxes
          this.resetForm();
          this.articles.forEach((areas) => {
            if (areas.isMultiSelect) {
              areas.paperRequestArticles.forEach((areasInfo) => {
                if (areasInfo.value) {
                  areasInfo.value = false;
                }
              });
            }
          });
          //  ----- end reset
        })
        .catch((error) => {
          if (data.paperRequestArticles[0] == undefined) {
            this.hello = true;

            this.loading = false;
          } else {
            this.snackbar.message = "Something goes wrong";
            this.$EventBus.$emit("snackbar", this.snackbar);
            this.loading = false;
          }
        });
    },
    resetForm() {
      this.file = "";
      this.documentObjectFinal.assignmentDueDate = "";
      this.documentObjectFinal.issues = "";
      this.documentObjectFinal.additionalComments = "";
      this.documentObjectFinal.isNativeLanguage = false;
      this.documentObjectFinal.educationLevelId = null;
      this.documentObjectFinal.majorId = null;
      this.documentObjectFinal.courseId = null;
      this.radioButtonValue = null;
      this.countedWordsOfDoc = "";
      this.priceOfCountedWordsOfDoc = "";
      this.hello = false;
    },
    docUploadEventHandler(event) {
      const file = event;
      if (file.size < 21027072) {
        this.documentObject.fileName = file.name.split(".")[0];
        this.documentObject.fileExtension = file.name.split(".")[1];

        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.documentObject.Base64String = reader.result.replace(
            /^data:.+;base64,/,
            ""
          );
          this.btnDisable = false;
        };
      } else {
        this.btnDisable = true;
      }
    },

    async fetchStudentProfile() {
      await this.axios
        .get("/Student/GetStudentProfile", {
          params: {
            userId: this.user.id,
            languageId: this.preferedLanguage,
          },
        })
        .then((response) => {
          this.student = response.data.userProfile;
          this.loading = false;
        })
        .catch((error) => {
          this.snackbar.message = error.response.data;
          this.$EventBus.$emit("snackbar", this.snackbar);
          this.loading = false;
        });
    },
    async fetchEducationLevelMajorCourse() {
      await this.axios
        .get("/StudentPaperSubmitted/GetStudentPaperDetails", {
          params: {
            languageId: this.preferedLanguage,
          },
        })
        .then((response) => {
          this.educationCoursesMajor = response.data.educationLevels;
          this.courses = response.data.courses;
          this.major = response.data.majors;

          this.articles = response.data.paperRequestCategories;
          this.articles.forEach((areas) =>
            areas.paperRequestArticles.forEach((f) => (f.value = false))
          );
          const areas = this.articles.paperRequestArticles;
        });
    },
  },

  mounted() {
    this.fetchStudentProfile();
    this.fetchEducationLevelMajorCourse();
  },
};
</script>

<style lang="scss" scoped>
.ask-mentor {
  .mission-section {
    .description {
      font-size: 1.125rem !important;
      line-height: 1.75rem !important;
    }
  }

  .class-informations {
    -webkit-box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.16);
    -moz-box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.16);
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.16);
    padding: 60px 0;

    .description {
      font-size: 1.125rem !important;
      line-height: 1.75rem !important;
    }

    .limitations-list {
      list-style: none;
      padding-left: 0;

      li {
        margin-bottom: 25px;
        font-size: 1.125rem !important;
        line-height: 1.5625rem !important;
        margin-left: 1em;

        &::before {
          content: " ";
          vertical-align: middle;
          width: 12px;
          height: 12px;
          border-radius: 5px;
          background-color: #567dfb;
          margin-right: 8px;
          display: inline-block;
          margin-left: -1em;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .document-decsription {
    -webkit-box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.16);
    -moz-box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.16);
    box-shadow: 0 0 0 0px rgb(0 0 0 / 16%);
    padding: 60px 0;
    .formatDescriptionText {
      font-size: 18px !important;
      font-weight: 400;
      line-height: 1.75rem;
      letter-spacing: normal !important;
      font-family: "Raleway", serif !important;
    }
  }

  .paper-information {

    .error-color {
      color: red;
    }
    padding: 60px 0;
    .category-title {
      font-size: 16px;
      font-family: "Raleway", serif !important;
      font-weight: 400;
      line-height: 0;
      color: #505050;
    }
    .formInfoText {
      font-size: 16px !important;
      font-weight: 400;
      line-height: 1.75rem;
      letter-spacing: normal !important;
      font-family: "Raleway", serif !important;
    }
    .steps {
      font-size: 25px;
      font-weight: 400;
      line-height: 1.75rem;
      font-family: "Raleway", serif !important;
      border-bottom: 1px solid #567dfb;
      margin-left: 20px;
    }
    .submission-text {
      font-size: 35px;
      font-weight: 400;
      line-height: 1.75rem;
      font-family: "Raleway", serif !important;
    }
    .paper-details {
      font-size: 25px;
      font-weight: 100;
      margin-bottom: 16px;
      font-family: "Raleway", serif !important;
    }
    .submitBtn {
      width: 200px;
      height: 50px;
      font-size: 25px;
      font-weight: 100;
      color: #ffffff !important;
      background: #567dfb !important;
      margin: 0 auto !important;
      display: block !important;
      font-family: "Raleway", serif !important;
      border-radius: 25px;
    }
    .submitBtn.theme--light.v-btn.v-btn--disabled {
      color: #ffffff !important;
      background: #567dfb !important;
      opacity: .4 !important;
      border-radius: 25px;
      cursor: not-allowed;
    }
    .submit-paper-title {
      margin-bottom: 16px;
      font-size: 25px;
      font-weight: 100;
      font-family: "Raleway", serif !important;
    }
    .lerner-information {
      margin-top: 46.5px;
      margin-bottom: 16px;
      font-size: 25px;
      font-weight: 100;
      font-family: "Raleway", serif !important;
    }
    .form-steps {
      display: flex;
      justify-content: space-around;
    }
    .thick-line {
      height: 1px;
      background-color: #000000;
      opacity: .14 !important;
    }
    .custom-label-position .v-label {
      margin-left: 20px;
    }
  }
}

@media only screen and (min-width: 1309px) and (max-width: 1440px) {
  .ask-mentor {
    .file-input {
      margin-top: 18px !important;
    }
  }
}

@media screen and (min-width: 1265px) {
  .ask-mentor {
    .file-input {
      margin-top: 41px;
    }
  }
}

@media screen and (max-width: 1263px) {
  .ask-mentor {
    .mission-section {
      h2 {
        margin-bottom: 20px;
      }
    }

    .class-informations {
      h2 {
        margin-bottom: 20px;
      }
    }

    .paper-information {
      padding: 60px 0;

      .form-steps {
        display: flex;
        justify-content: space-around;
      }
    }
  }
}

@media screen and (max-width: 575px) {
  .ask-mentor {
    .mission-section {
      h2 {
        font-size: 1.5625rem !important;
        line-height: 2.1875rem !important;
      }
    }
    .paper-information{
      .ml-4{
        margin-right: 0;
      }
    }
    .class-informations {
      h2 {
        font-size: 1.5625rem !important;
        line-height: 2.1875rem !important;
      }

      .description {
        font-size: 0.9375rem !important;
        line-height: 1.5625rem !important;
      }

      .limitations-list {
        li {
          font-size: 0.9375rem !important;
          line-height: 1.5625rem !important;
        }
      }
    }
  }
}
</style>